import GlassCard from '@/components/GlassCard';
import ThemeWrapper from '@/components/ThemeWrapper';
import AppLayout from '@/layouts/AppLayout';
import { AlertCircle } from 'lucide-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

const PlacementUnavailableContent: React.FC = () => {
    const { t } = useTranslation();

    return (
        <AppLayout>
            <div className="min-h-screen flex items-center justify-center px-4 py-8">
                <GlassCard className="max-w-lg w-full p-10 text-center">
                    <div className="inline-flex h-16 w-16 items-center justify-center rounded-full bg-amber-100 mb-6">
                        <AlertCircle size={32} className="text-amber-600" />
                    </div>
                    <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-3">
                        {t('evaluation.placement.unavailableTitle')}
                    </h1>
                    <p className="text-gray-600 dark:text-neutral-300">
                        {t('evaluation.placement.unavailableBody')}
                    </p>
                </GlassCard>
            </div>
        </AppLayout>
    );
};

const PlacementUnavailable: React.FC = () => {
    return (
        <ThemeWrapper>
            <PlacementUnavailableContent />
        </ThemeWrapper>
    );
};

export default PlacementUnavailable;
